"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RateShoppingScheme = exports.SignatureRequirementScope = exports.InventoryDistributionType = void 0;
var InventoryDistributionType;
(function (InventoryDistributionType) {
    InventoryDistributionType["ONE_NODE_ZBP"] = "ONE_NODE_ZBP";
    InventoryDistributionType["MULTI_NODE_ZBP"] = "MULTI_NODE_ZBP";
    InventoryDistributionType["DISTRIBUTED_UNIT_PRICING"] = "DISTRIBUTED_UNIT_PRICING";
})(InventoryDistributionType = exports.InventoryDistributionType || (exports.InventoryDistributionType = {}));
var SignatureRequirementScope;
(function (SignatureRequirementScope) {
    SignatureRequirementScope["ACCOUNT"] = "ACCOUNT";
    SignatureRequirementScope["PRODUCT"] = "PRODUCT";
})(SignatureRequirementScope = exports.SignatureRequirementScope || (exports.SignatureRequirementScope = {}));
var RateShoppingScheme;
(function (RateShoppingScheme) {
    RateShoppingScheme["HYBRID_ACCOUNTS"] = "HYBRID_ACCOUNTS";
    RateShoppingScheme["SELLER_ONLY_ACCOUNTS"] = "SELLER_ONLY_ACCOUNTS";
    RateShoppingScheme["FLEXPORT_ONLY_ACCOUNTS"] = "FLEXPORT_ONLY_ACCOUNTS";
})(RateShoppingScheme = exports.RateShoppingScheme || (exports.RateShoppingScheme = {}));
//# sourceMappingURL=Settings.js.map